import { render, staticRenderFns } from "./DevicesLayout.vue?vue&type=template&id=50845278&"
import script from "./DevicesLayout.vue?vue&type=script&lang=js&"
export * from "./DevicesLayout.vue?vue&type=script&lang=js&"
import style0 from "./DevicesLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports